var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import GenericTable from "../../../../../shared-library/components/GenericTable";
import di from "../di/serviceLocator";
var MFRegistrationPopup = function (props) {
    var _a, _b, _c;
    var _d = __read(React.useState(false), 2), loader = _d[0], setLoader = _d[1];
    var _e = __read(React.useState([]), 2), transActionData = _e[0], setTransActionData = _e[1];
    var transactionColumns = [
        {
            columnName: "Transaction Date",
            key: "TransactionDate",
        },
        {
            columnName: "Buy / Sell",
            key: "BuySell",
        },
        {
            columnName: "Order Status",
            key: "OrderStatus",
        },
        {
            columnName: "Amount",
            key: "Amount",
        },
        {
            columnName: "Units",
            key: "Units",
        },
        {
            columnName: "Order Remark",
            key: "OrderRemark",
        },
        {
            columnName: "SIP Regn No",
            key: "SIPRegnNo",
        },
        {
            columnName: "Exchange",
            key: "Exchange",
        },
    ];
    var getMfSubDetails = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoader(true);
                    return [4 /*yield*/, di.clients
                            .getMFRegistrationBookAccodeData({
                            acCode: data === null || data === void 0 ? void 0 : data.acCode,
                            sipRegNo: data === null || data === void 0 ? void 0 : data.sipRegnNo,
                        })
                            .then(function (data) {
                            setTransActionData(data);
                            setLoader(false);
                        })
                            .catch(function (error) {
                            setLoader(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.data)
            getMfSubDetails(props === null || props === void 0 ? void 0 : props.data);
    }, [props === null || props === void 0 ? void 0 : props.data]);
    return (React.createElement("div", null,
        React.createElement("table", { className: "mandateid-table" },
            React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                React.createElement("tr", null,
                    React.createElement("th", null, "Mandate Id"),
                    React.createElement("th", null, "Mandate Status"),
                    React.createElement("th", null, "Exchange"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { className: "DMSanM_14_500 txt-midnight-blue" }, (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.mandateID),
                    React.createElement("td", { className: "DMSanM_14_500" }, (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.mandateStatus),
                    React.createElement("td", { className: "DMSanN_14_400 txt_blackOne1" }, (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.exchange)))),
        React.createElement(GenericTable, { tableClassName: "transaction-table", data: transActionData, columns: transactionColumns, loader: loader, message: {
                msg: "No Data Found",
                show: transActionData && (transActionData === null || transActionData === void 0 ? void 0 : transActionData.length) === 0,
                icon: "",
            } })));
};
export default MFRegistrationPopup;
